// Monta o payload usado tanto para cadastro quanto para edição
export const buildBannerPayload = ({ bannerData, uploads, selected }) => {
  // pega apenas uploads que possuem arquivo novo enviado
  const validUploads = uploads.filter((i) => i.file);

  const formData = new FormData();

  const isEditingBanner = !!bannerData?.banner_id;

  // se estiver editando, envia também o banner_id
  if (isEditingBanner) {
    formData.append("banner_id", bannerData.banner_id);
  }

  // adiciona os campos principais do banner
  formData.append("banner_name", bannerData.banner_name);
  formData.append("category", bannerData.category);
  formData.append("link_destination", bannerData.link_destination);
  formData.append("priority", bannerData.priority);

  // transforma arrays em string JSON antes de enviar
  formData.append(
    "profile_can_view",
    JSON.stringify(bannerData.profile_can_view),
  );
  formData.append(
    "plan_name_can_view",
    JSON.stringify(bannerData.plan_name_can_view),
  );

  // no cadastro adiciona a tela onde o banner será exibido
  if (!isEditingBanner) {
    formData.append("displayed_screen", selected);
  }

  // adiciona apenas se existir valor
  const safeAppend = (key, value) => {
    if (value && value !== "undefined") {
      formData.append(key, value);
    }
  };
  // adiciona datas somente se estiverem preenchidas
  safeAppend("end_date", bannerData.end_date);
  safeAppend("start_date", bannerData.start_date);

  // adiciona apenas imagens novas enviadas
  validUploads.forEach((element) => {
    formData.append(element.id, element.file);
  });

  return formData;
};
